import { useRef, useEffect } from 'react';
import useReactHookFormProps from '../../../hooks/useReactHookFormProps';

export default function useApplicationFormReactHookFormProps({
  initialValues,
  applicantId,
  applicationId,
  isLoading,
}) {
  const ReactHookFormProps = useReactHookFormProps({
    defaultValues: {},
    mode: 'onChange',
  });

  // Track if we've already initialized the form with values
  const hasInitializedRef = useRef(false);

  // Reset initialization flag when applicantId or applicationId changes
  useEffect(() => {
    hasInitializedRef.current = false;
  }, [applicantId, applicationId]);

  // Reset form with initialValues once they're ready
  useEffect(() => {
    // Check if initialValues are ready (not empty object and not loading)
    const hasValues = initialValues && Object.keys(initialValues).length > 0;

    if (!isLoading && hasValues && !hasInitializedRef.current) {
      // No validation pass here: reset() drops every registered field, so a
      // trigger() issued alongside it validates nothing, and the fields that
      // only appear once the loaded values are in place (a minors group, a
      // "Reason" behind a radio) mount after any pass that runs on load. The
      // saved values are validated when the user asks to complete the form,
      // once every field is on screen.
      ReactHookFormProps.reset(initialValues);
      hasInitializedRef.current = true;
    }
  }, [initialValues, isLoading, ReactHookFormProps]);

  return ReactHookFormProps;
}
